import Seo from "@/components/Seo";
import { Eyebrow, H2, Body, Section } from "@/components/Type";
import { useWaitlist } from "@/context/waitlist";

const BELIEFS = [
  "THE BODY IS A SYSTEM.",
  "REPEATED SIGNALS CREATE ADAPTATION.",
  "CONTEXT MATTERS.",
  "SCIENCE SHOULD BECOME PRACTICAL.",
  "DISCIPLINE MATTERS.",
  "TIME COMPOUNDS EVERYTHING.",
  "HEALTH IS SOMETHING WE BUILD.",
];

export default function AboutPage() {
  const openWaitlist = useWaitlist();

  return (
    <>
      <Seo
        title="About | W8ED"
        description="W8ED is a human health company. Weight is not just what you carry — it is what accumulates."
        path="/about"
      />
      <section className="px-6 pb-20 pt-32 sm:pt-40">
        <div className="mx-auto max-w-6xl">
          <Eyebrow>About W8ED</Eyebrow>
          <h1 className="mt-8 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#f5f2ea] sm:text-6xl">
            WEIGHT IS NOT JUST WHAT YOU CARRY.
            <br />
            <span className="text-[#C9A227]">IT IS WHAT ACCUMULATES.</span>
          </h1>
        </div>
      </section>

      <Section>
        <Eyebrow>Why W8ED Exists</Eyebrow>
        <H2 className="mt-6">HEALTH HAS BECOME FRAGMENTED.</H2>
        <Body>
          Nutrition here. Fitness there. Sleep somewhere else. Supplements somewhere else.
          Behaviour treated as an afterthought.
        </Body>
        <Body>
          But the body does not operate that way. The body is a system. W8ED exists to bring that
          system back together.
        </Body>
      </Section>

      <Section>
        <Eyebrow>What We Believe</Eyebrow>
        <div className="mt-10 border-t border-[#1f1e1a]">
          {BELIEFS.map((b) => (
            <p
              key={b}
              className="border-b border-[#1f1e1a] py-6 font-display text-xl font-bold tracking-tight text-[#b8b3a6] sm:text-2xl"
            >
              {b}
            </p>
          ))}
        </div>
      </Section>

      <Section>
        <Eyebrow>What We Are Building</Eyebrow>
        <H2 className="mt-6">WE ARE NOT BUILDING ANOTHER WELLNESS BRAND.</H2>
        <Body>
          W8ED is building a connected human health ecosystem — where each part strengthens the
          others.
        </Body>
        <p className="mt-10 font-mono text-[10px] tracking-[0.25em] leading-loose text-[#b8b3a6]">
          SCIENCE <span className="text-[#C9A227]">→</span> NUTRITION{" "}
          <span className="text-[#C9A227]">→</span> PRODUCTS{" "}
          <span className="text-[#C9A227]">→</span> PROGRAMMES{" "}
          <span className="text-[#C9A227]">→</span> TECHNOLOGY{" "}
          <span className="text-[#C9A227]">→</span> BEHAVIOUR{" "}
          <span className="text-[#C9A227]">→</span> HEALTH
        </p>
      </Section>

      <Section>
        <Eyebrow>The Name</Eyebrow>
        <H2 className="mt-6">W8ED IS PRONOUNCED "WEIGHTED".</H2>
        <Body>
          Everything we do carries weight. Every meal. Every movement. Every night of sleep. Every
          stressful day. Every recovery session. Every decision. Every repeated behaviour.
        </Body>
        <Body>The question is: what happens when they accumulate?</Body>
      </Section>

      <section className="border-t border-[#1f1e1a] px-6 py-32 text-center sm:py-40">
        <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-[#57534a]">
          You are what you repeat.
        </p>
        <p className="mt-4 font-mono text-[10px] tracking-[0.35em] uppercase text-[#C9A227]">
          Discipline &gt; Dopamine.
        </p>
        <button
          type="button"
          data-testid="about-join"
          onClick={openWaitlist}
          className="mt-10 border border-[#3a3524] px-8 py-4 font-mono text-[11px] tracking-[0.3em] uppercase text-[#C9A227] transition-colors hover:border-[#C9A227]"
        >
          JOIN THE W8LIST
        </button>
      </section>
    </>
  );
}
